define('models/comments',[
  "globals",
  "backbone",
  "moment",
  "marked",
  "URIjs"
], function (globals, Backbone, moment, marked, URI) {
  "use strict";

  return Backbone.Model.extend({
    fields: ["content", "status", "severity", "attachment"],

    initialize: function () {
      marked.setOptions({
        renderer: new marked.Renderer(),
        gfm: true,
        tables: false,
        breaks: true,
        pedantic: true,
        sanitize: true,
        smartLists: true,
        smartypants: true
      });

      return this;
    },

    comparator: "position",

    url: function () {
      var base = _.result(this, "urlRoot") || _.result(this.collection, "url");
      if (this.isNew()) return base;
      return URI.joinPaths(base, this.id).path();
    },

    attributeIsOneOf: function (attr, values) {
      return _.isEmpty(values) ||
             _.isEqual(values, ["default"]) ||
             _.contains(values, this.get(attr));
    },

    getHref: function () {
      var lib = this.get("library"),
          path = this.get("path"),
          ctx = $("body").data("application-context");
      return new URI(["content", lib.id, lib.version, lib.language, path].join("/") , ctx)
                    .normalize().href();
    },

    toFormattedJSON: function () {
      var m = this.toJSON();
      var lang = $("main").data("uilanguage");
      if(lang == undefined) lang = "en";

      m.href = this.getHref();

      m.created = {
        dateTime: new Date(m.created),
        fromNow: moment(m.created).locale(lang).fromNow()
      };

      if (this.has("modified")) {
        m.modified = {
          dateTime: new Date(m.modified),
          fromNow: moment(m.modified).locale(lang).fromNow()
        };
      }

      _.each(["status", "severity", "attachment"], function (p) {
        if (this.has(p)) {
          m[p] = {
            text: m[p],
            className: m[p].replace(/\s/g, "_").replace(/[^\w\s]/gi, "").toLowerCase()
          };
        }
      }, this);

      m.content = marked(m.content);
      return m;
    }
  });
});

